import { render, staticRenderFns } from "./toileting-page.vue?vue&type=template&id=41990f6e"
import script from "./toileting-page.vue?vue&type=script&lang=js"
export * from "./toileting-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports